var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"custom-control",class:_vm.stateClass,attrs:{"name":_vm.name,"autocomplete":"off","disabled":_vm.disabled},domProps:{"value":_vm.transformValue},on:{"change":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }